var map = {
	"./about.jpg": "./images/about.jpg",
	"./about.png": "./images/about.png",
	"./bg.png": "./images/bg.png",
	"./bg2.png": "./images/bg2.png",
	"./hero-background.jpg": "./images/hero-background.jpg"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./images sync recursive \\.(png%7Cjpe?g)$";